/**
 * Airbank Constants
 * Configuration and constant values for Airbank feature
 */

export const AIRBANK_CONFIG = {
  // Registration limits
  MIN_DNA_LENGTH: 32,
  MAX_DNA_LENGTH: 256,
  MIN_ENTITY_PROOF_LENGTH: 16,
  MAX_ENTITY_PROOF_LENGTH: 128,
  MIN_NAME_LENGTH: 2,
  MAX_NAME_LENGTH: 50,

  // Verification statuses
  VERIFICATION_STATUS: {
    PENDING: "pending",
    VERIFIED: "verified",
    REJECTED: "rejected",
    EXPIRED: "expired",
  } as const,

  // Registration steps
  REGISTRATION_STEPS: [
    {
      id: "dna_submission",
      step_number: 1,
      title: "Submit AI Twin DNA",
      description: "Upload your AI Twin's DNA hash for storage",
      status: "pending" as const,
    },
    {
      id: "entity_verification",
      step_number: 2,
      title: "Verify Entity",
      description: "Provide entity proof for verification",
      status: "pending" as const,
    },
    {
      id: "dna_verification",
      step_number: 3,
      title: "DNA Verification",
      description: "Wait for Airbank to verify your AI Twin DNA",
      status: "pending" as const,
    },
    {
      id: "badge_issuance",
      step_number: 4,
      title: "Badge Issuance",
      description: "Receive your verified badge",
      status: "pending" as const,
    },
  ],

  // API endpoints (for reference)
  ENDPOINTS: {
    REGISTER: "/api/v1/airbank/talents/:talentId/register-dna",
    STATUS: "/api/v1/airbank/talents/:talentId/status",
    VERIFY: "/api/v1/airbank/talents/:talentId/verify",
    VERIFICATION_STATUS:
      "/api/v1/airbank/talents/:talentId/verification-status",
  },

  // Badge configuration
  BADGE: {
    DEFAULT_SIZE: 64,
    LARGE_SIZE: 128,
    SMALL_SIZE: 32,
    ANIMATION_DURATION: 300,
  },

  // Messages
  MESSAGES: {
    REGISTRATION_SUCCESS: "AI Twin DNA registered successfully in Airbank!",
    REGISTRATION_FAILED: "Failed to register AI Twin DNA. Please try again.",
    VERIFICATION_SUCCESS: "AI Twin verified successfully! Badge issued.",
    VERIFICATION_FAILED: "Verification failed. Please check your submission.",
    VERIFICATION_PENDING: "Verification is in progress. Please wait.",
    VERIFICATION_REJECTED:
      "Verification was rejected. Please review and resubmit.",
    DNA_REQUIRED: "AI Twin DNA is required",
    ENTITY_PROOF_REQUIRED: "Entity proof is required",
    NAME_REQUIRED: "AI Twin name is required",
    INVALID_DNA_FORMAT: "Invalid DNA format",
    INVALID_ENTITY_PROOF: "Invalid entity proof format",
  },

  // Validation patterns
  VALIDATION: {
    DNA_PATTERN: /^[a-zA-Z0-9_-]{32,256}$/,
    ENTITY_PROOF_PATTERN: /^[a-zA-Z0-9_-]{16,128}$/,
    NAME_PATTERN: /^[a-zA-Z0-9\s\-_]{2,50}$/,
  },
} as const;

export const AIRBANK_ROUTES = {
  REGISTER: "/talent/airbank/register",
  STATUS: "/talent/airbank/status",
  VERIFY: "/talent/airbank/verify",
  MANAGE: "/talent/airbank/manage",
  EDIT: "/talent/airbank/manage/edit",
  /** Who used your registered AI-DNA images */
  DNA_IMAGE_USAGE_LOGS: "/talent/airbank/dna-image-usage-logs",
} as const;
